'use client'

import { useEffect, useRef, useState } from "react"
import Button from "../button/Button"
import KeyValue from "../value/KeyValue"
import Field from "../form/Field"
import { strings } from "@/utils/I18n"
import { formatCurrency, formatNumber } from "@/utils/Formatters"
import { DM_EVENT_TRADE_ESTIMATE, DM_FIELDS, useDMEventListener } from "@dealermesh/react"
import useEventListener, { emitEvent } from "../plugins/EventListener"
import Icon from "../icon/Icon"


export default function TradeSlider(props) {
  
  const slide = useRef()
  
  const conf = props.site.trade
  
  const [trade,setTrade] = useState(props.trade)
  const [initTradeValue,setInitTradeValue] = useState(props.tradeInValue || (props.trade ? props.trade.value : 0))
  const [min,setMin] = useState(props.trade ? props.trade.value_low - (conf.slider?.min_markup || 0) : 0)
  const [max,setMax] = useState(props.trade ? props.trade.value_high + (conf.slider?.max_markup || 0) : (props.vehicle?.price || 25000))
  const [tradeInValue,setTradeInValue] = useState(initTradeValue)
  
  useDMEventListener(DM_EVENT_TRADE_ESTIMATE, event => {
    if (event.detail?.value) {
      setTrade(event.detail)
      setInitTradeValue(event.detail?.value)
      setTradeInValue(event.detail?.value)
      setMin(event.detail ? event.detail.value_low - (conf.slider?.min_markup || 0) : 0)
      setMax(event.detail ? event.detail.value_high + (conf.slider?.max_markup || 0) : (props.vehicle?.price || 25000))
    }
  })

  useEventListener("trade_removed", event => {
    setTrade(null)
    setInitTradeValue(0)
    setTradeInValue(0)
    setMin(0)
    setMax((props.vehicle?.price || 25000))
  })

  useEffect(() => {
    setTradeInValue(props.tradeInValue)
    if (props.tradeInValue > 0) {
      slide.current.updateValue(props.tradeInValue)
    }
  }, [props.tradeInValue])
  
  useEffect(() => {
    setMin(props.trade ? props.trade.value_low - (conf.slider?.min_markup || 0) : 0)
    setMax(props.trade ? props.trade.value_high + (conf.slider?.max_markup || 0) : (props.vehicle?.price || 25000))
  }, [props.trade])
  
  const toggleTradeForm = (e) => {
    e.preventDefault()
    if (props.toggleForm) {
      props.toggleForm(e)
    } else {
      emitEvent("show_trade_slide")
    }
  }
  
  const onChange = (value) => {
    setTradeInValue(value)
    props.onChange(value)
  }
  
  return <>
    <Button theme={['plain']} onClick={e => toggleTradeForm(e)} label={strings(props.site)['dr_tradeInValue']}>
      <KeyValue label={strings(props.site)['dr_tradeInValue'] + ( props.site.session?.vehicles?.trade && tradeInValue ? " (" + parseInt(props.site.session?.vehicles?.trade.year) + ' ' + props.site.session?.vehicles?.trade.model_name + ")" : '' )} value={formatCurrency(tradeInValue)}>
        { (!trade && !tradeInValue) ?
        <span>Add+</span>
        :
        <span title={ props.site.session?.vehicles?.trade?.make_name + ' ' + props.site.session?.vehicles?.trade?.model_name }>
          <Icon {...props} name="trade"></Icon>
        </span>
        }
      </KeyValue>
    </Button>
    { (!conf?.slider?.disabled || props.slider) &&
    <div className={ props.sliderClass }>
      <Field ref={slide} key={min + "-" + max} name={DM_FIELDS.DR_TRADE_VALUE} type="slider" min={min} max={max} value={initTradeValue || 1} step={50} onChange={value => onChange(value)} disabled={props.disabled || trade?.trade_id} onDisabledClick={props.onDisabledClick}></Field>
    </div>
    }
  </>

  
}